import { normalizeDailyBar } from "../market-data/normalize";
import type { MarketSnapshot } from "../market-data/types";
import { getSymbolDefinition } from "../market-data/symbols";

const retrievedAt = "2026-06-20T00:00:00.000Z";

function snapshot(symbolId: string, label: string, dateLabel: string, bar: ReturnType<typeof normalizeDailyBar>): MarketSnapshot {
  const symbol = getSymbolDefinition(symbolId);
  return {
    ...bar,
    symbolId,
    label,
    shortLabel: symbol.shortLabel,
    market: symbol.market,
    currency: symbol.currency,
    timezone: symbol.timezone,
    decimals: symbol.decimals,
    flagOrIcon: symbol.flagOrIcon,
    status: "available",
    source: "fixture",
    dataAsOf: bar.date,
    retrievedAt,
    pathSource: "synthetic_from_ohlc",
    // UI-specific date label is handled by scenario metadata.
  };
}

export const ACTUAL_SP500 = snapshot(
  "sp500",
  "S&P 500",
  "JUN 18, 2026 / US CLOSE",
  normalizeDailyBar({
    date: "2026-06-18",
    previousClose: 7420.1,
    open: 7487.36,
    high: 7511.07,
    low: 7468.32,
    close: 7500.58,
    volume: 6324161903
  })
);

export const SURGE_SP500 = snapshot(
  "sp500",
  "S&P 500",
  "SURGE DEMO / LOCAL TIME",
  normalizeDailyBar({
    date: "2026-06-17",
    previousClose: 7511.35,
    open: 7498.2,
    high: 7618.4,
    low: 7476.8,
    close: 7606.7
  })
);

export const CRASH_SP500 = snapshot(
  "sp500",
  "S&P 500",
  "CRASH DEMO / LOCAL TIME",
  normalizeDailyBar({
    date: "2026-06-17",
    previousClose: 7511.35,
    open: 7526.6,
    high: 7542.3,
    low: 7392.4,
    close: 7405.2
  })
);

export const FIXTURE_SNAPSHOTS = [ACTUAL_SP500, SURGE_SP500, CRASH_SP500];

export const SCENARIO_LABELS = {
  actual: "Actual",
  surge: "Surge demo",
  crash: "Crash demo",
  manual: "Manual"
} as const;

export type ScenarioId = keyof typeof SCENARIO_LABELS;

export function createManualSnapshot(input: {
  symbolId: string;
  previousClose: number;
  open: number;
  high: number;
  low: number;
  close: number;
  date: string;
}): MarketSnapshot {
  const symbol = getSymbolDefinition(input.symbolId);
  const bar = normalizeDailyBar(input);
  return {
    ...bar,
    symbolId: symbol.id,
    label: symbol.label,
    shortLabel: symbol.shortLabel,
    market: symbol.market,
    currency: symbol.currency,
    timezone: symbol.timezone,
    decimals: symbol.decimals,
    flagOrIcon: symbol.flagOrIcon,
    status: "available",
    source: "manual",
    dataAsOf: bar.date,
    retrievedAt: new Date().toISOString(),
    pathSource: "manual"
  };
}
